// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { locationSearchFormStyles } from "@sc/Overrides/Components/LocationSearchForm";
import { css } from "styled-components";

locationSearchFormStyles.locationNameLink = {
    color: "primary",
    typographyProps: {
        weight: "bold",
        ellipsis: true,
        size: 16,
        lineHeight: "20px",
    },
};

locationSearchFormStyles.searchResultLocationGridItem = {
    width: 11,
    css: css`
        align-items: center;
    `,
};

locationSearchFormStyles.searchResultPhoneGridItem = {
    width: [11, 11, 11, 11, 3],
    css: css`
        align-items: center;
    `,
};

locationSearchFormStyles.searchResultPhoneLink = {
    typographyProps: {
        size: 16,
        weight: "normal",
        lineHeight: "20px",
    },
};

locationSearchFormStyles.searchResultContentGridItem = {
    width: [11, 2, 2, 2, 2],
    css: css`
        align-items: center;
    `,
};

locationSearchFormStyles.locationContentLink = {
    typographyProps: {
        size: 16,
        weight: "normal",
        lineHeight: "20px",
    },
};

locationSearchFormStyles.searchResultGoogleMapsDirectionLinkGridItem = {
    width: [11, 2, 2, 2, 2],
    css: css`
        align-items: center;
    `,
};

locationSearchFormStyles.locationGoogleMapsDirectionLink = {
    typographyProps: {
        size: 16,
        weight: "normal",
        lineHeight: "20px",
    },
};

locationSearchFormStyles.searchResultDistanceGridItem = {
    width: [11, 4, 4, 4, 4],
};

locationSearchFormStyles.mobileOffsetGridItem = {
    width: [1, 0, 0, 0, 0],
};

locationSearchFormStyles.searchButtonGridItem = {
    width: [12, 12, 12, 12, 2],
    css: css`
        padding-top: 10px;
        display: inline-block;
        width: 100%;
        flex-direction: row;
        text-align: right;
        align-self: flex-end;
        & > div {
            display: inline-flex;
        }
    `,
};

locationSearchFormStyles.searchLocationsGridItem = {
    width: [12, 12, 12, 12, 6],
};

locationSearchFormStyles.searchResultDivider = {
    css: css`
        margin: 0;
        border: 1px solid rgba(74, 74, 74, 0.2);
        width: 100%;
    `,
};

locationSearchFormStyles.searchContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        height: 642px;
    `,
};

locationSearchFormStyles.searchResultDisplayNumberGridItem = {
    width: 1,
};

locationSearchFormStyles.searchResultRow = {
    css: css`
        overflow-y: auto;
        overflow-x: hidden;
        flex: 1;
    `,
};

locationSearchFormStyles.searchResultsTextGridItem = {
    width: 4,
    css: css`
        align-items: flex-end;
    `,
};
